import type { SyntheticEvent } from 'react';
import Alert from '@mui/material/Alert';
import DefaultSnackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';

import _noop from '@julofinance/web-helpers/dist/fn/noop';

import { SnackbarProps } from './types';
import { SNACKBAR_AUTO_HIDE_DURATION } from './constants';

const Snackbar = (props: SnackbarProps) => {
  const {
    open,
    onClose = _noop,
    severity,
    autoHideDuration = SNACKBAR_AUTO_HIDE_DURATION,
    anchorOrigin = { horizontal: 'right', vertical: 'top' },
    message,
    ...resProps
  } = props;

  const handleClose = (
    event: Event | SyntheticEvent<unknown, Event>,
    reason: SnackbarCloseReason = 'timeout',
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    onClose(event, reason);
  };

  return (
    <DefaultSnackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      autoHideDuration={autoHideDuration}
      {...resProps}
    >
      <Alert onClose={handleClose} severity={severity}>
        {message}
      </Alert>
    </DefaultSnackbar>
  );
};

export default Snackbar;
